<header class="sticky top-0 z-50 w-full bg-[#1F2FA3] shadow-md">

  <div class="mx-auto flex h-28 max-w-full items-center px-4 sm:px-6 lg:px-8">

    <!-- Logo -->
    <div class="flex shrink-0 items-center">
      <a
        [routerLink]="homeRoute"
          (click)="navigateHome()"
        class="flex items-center"
        aria-label="Energia MENSA Home"
      >
        <img
          src="assets/images/energia-mensa-logo.png"
          alt="Energia MENSA"
          class="h-22 w-22 rounded-full bg-white object-contain"
        />
      </a>
    </div>

    <!-- Desktop Navigation -->
    <nav class="ml-auto hidden items-center md:flex">

    @if (showPublicLinks) {
      <a
          [routerLink]="homeRoute"
          (click)="navigateHome()"
          routerLinkActive="bg-[#17288F]"
          [routerLinkActiveOptions]="{ exact: true }"
          class="px-5 py-2 text-lg font-medium text-white transition-colors duration-200 hover:bg-[#17288F]"
        >
          Home
        </a>

          <a
            href="javascript:void(0)"
            routerLinkActive="bg-[#17288F]"
            (click)="navigateToPublicPage('about-us')"
            class="px-5 py-2 text-lg font-medium text-white transition-colors duration-200 hover:bg-[#17288F]">
            About Us
          </a>

          <a
            href="javascript:void(0)"
            routerLinkActive="bg-[#17288F]"
            (click)="navigateToPublicPage('contact-us')"
            class="px-5 py-2 text-lg font-medium text-white transition-colors duration-200 hover:bg-[#17288F]">
            Contact Us
          </a>

          <a
            href="javascript:void(0)"
            routerLinkActive="bg-[#17288F]"
            (click)="navigateToPublicPage('support')"
            class="px-5 py-2 text-lg font-medium text-white transition-colors duration-200 hover:bg-[#17288F]">
            Support
          </a>
       }

    </nav>

    <!-- Right Section -->
    <div class="ml-4 hidden items-center gap-3 md:flex">

      <!-- MENSA India -->
      <div class="flex items-center gap-1 text-white">

        <img
          src="assets/images/mensa-india.png"
          alt="MENSA"
          class="h-16 w-16 rounded-full object-contain"
        />

        <span class="text-xl font-semibold tracking-wide">
          MENSA INDIA
        </span>

      </div>

    </div>

    <!-- Mobile Menu Button -->
    <button
      type="button"
      class="ml-auto flex items-center justify-center rounded-md
             p-2 text-white hover:bg-[#17288F] md:hidden"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="isMobileMenuOpen"
      aria-label="Toggle navigation"
    >

      @if (!isMobileMenuOpen) {

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>

      } @else {

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>

      }

    </button>

  </div>


  <!-- Mobile Navigation -->
  @if (isMobileMenuOpen) {

    <div class="border-t border-white/20 bg-[#17288F] md:hidden">

      <nav class="flex flex-col px-4 py-3">

        <a
  [routerLink]="homeRoute"
  routerLinkActive="bg-white/10"
  [routerLinkActiveOptions]="{ exact: true }"
  class="rounded px-4 py-3 text-sm text-white"
  (click)="closeMobileMenu()"
>
  Home
</a>

        @if (showPublicLinks) {
  <a
    routerLink="/about-us"
    routerLinkActive="bg-white/10"
    class="rounded px-4 py-3 text-sm text-white"
    (click)="closeMobileMenu()"
  >
    About Us
  </a>

  <a
    routerLink="/contact-us"
    routerLinkActive="bg-white/10"
    class="rounded px-4 py-3 text-sm text-white"
    (click)="closeMobileMenu()"
  >
    Contact Us
  </a>

  <a
    routerLink="/support"
    routerLinkActive="bg-white/10"
    class="rounded px-4 py-3 text-sm text-white"
    (click)="closeMobileMenu()"
  >
    Support
  </a>

}

        <div class="mt-2 border-t border-white/20 pt-3">

          <div class="flex items-center gap-3 px-4 py-2 text-white">

           <img
          src="assets/images/mensa-india.png"
          alt="MENSA"
          class="h-16 w-16 rounded-full object-contain"
        />

            <span class="text-sm font-semibold">
              MENSA INDIA
            </span>

          </div>

        </div>

      </nav>

    </div>

  }

</header>
